module.exports = __webpack_public_path__ + "static/media/helping-others-large@3x.ad992ce6.png";